import type { Ref } from 'vue';

import useCrudQuery from '~/shared/hooks/useCrudQuery';

import capitalMarketsService, {
  type GetCapitalMarketsOperationsRequest,
  type GetCapitalMarketsOperationsResponse,
} from '../services/capitalMarketsService';

export default function useCessions(params: Ref<GetCapitalMarketsOperationsRequest>) {
  return useCrudQuery<GetCapitalMarketsOperationsRequest, GetCapitalMarketsOperationsResponse>(
    params,
    'cessions',
    capitalMarketsService.list.bind(capitalMarketsService),
  );
}
